import { render, staticRenderFns } from "./AiReportModal.vue?vue&type=template&id=36da1336&scoped=true"
import script from "./AiReportModal.vue?vue&type=script&lang=js"
export * from "./AiReportModal.vue?vue&type=script&lang=js"
import style0 from "./AiReportModal.vue?vue&type=style&index=0&id=36da1336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da1336",
  null
  
)

export default component.exports